module.exports = __webpack_public_path__ + "img/instagram_input_story.1de90212.png";